import React, { useContext, useEffect } from 'react';
import '../../../styles/irctcOtpVerifyPage.css';
import FacingTrouble from '../../components/FacingTrouble';
import InputField from '../../components/InputField';
import axios from 'axios';
import {
  FACING_TROUBLE_PAGE_TITLE,
  getFacingTroubleList,
  IRCTC_CREATE_ACCOUNT_COMPONENTS,
  SERVER_URL
} from '../../../utils/RailsSEOConstants';
import { IrctcCreateAccountContext } from '../IrctcCreateAccountPage';
import * as irctcCreateAccountActions from './../../../actions/irctcCreateAccountActions';
import useTimer from '../../components/useTimer';
import PropTypes from 'prop-types';
import { isMobile } from '../../../utils/commonUtils';

const IrctcOtpVerifyPage = (props) => {
  const { customClass } = props;
  const isMobileDevice = isMobile();
  const context = useContext(IrctcCreateAccountContext);
  const {
    createAccountState: { userName, userEmail, mobileNumber, emailCode, smsCode, showErrorOtpPage },
    createAccountDispatch
  } = context;
  const updateComponentToShow = (latestComponentToShow) => {
    createAccountDispatch({
      type: irctcCreateAccountActions.ACTION_SET_COMPONENT_CREATE_ACCOUNT,
      data: latestComponentToShow
    });
  };
  const updateShowErrorOtpPage = (latestError) => {
    createAccountDispatch({
      type: irctcCreateAccountActions.ACTION_SET_SHOW_ERROR_OTP_PAGE,
      data: latestError
    });
  };
  const updateEmailCode = (latestEmailCode) => {
    if (showErrorOtpPage) {
      updateShowErrorOtpPage(false);
    }
    createAccountDispatch({
      type: irctcCreateAccountActions.ACTION_SET_EMAIL_CODE_CREATE_ACCOUNT,
      data: latestEmailCode
    });
  };
  const updateSmsCode = (latestSmsCode) => {
    if (showErrorOtpPage) {
      updateShowErrorOtpPage(false);
    }
    createAccountDispatch({
      type: irctcCreateAccountActions.ACTION_SET_SMS_CODE_CREATE_ACCOUNT,
      data: latestSmsCode
    });
  };

  const { timerString, timerExpired } = useTimer(120);

  const sendOtpToUser = async (resendMode, forceApiCall) => {
    // M -> mobile
    // E -> Email
    // B -> Both
    if (timerExpired || forceApiCall) {
      try {
        await axios.get(`${SERVER_URL}/user/getOtp/${userName}/${resendMode}`);
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error(error);
      }
    }
  };
  const submitOtpForm = async () => {
    try {
      const res = await axios.get(`${SERVER_URL}/user/verifyOtp/${userName}/B`, {
        params: {
          emailCode: emailCode || '',
          smsCode: smsCode || ''
        }
      });
      const { error } = res.data;
      if (!error) {
        updateComponentToShow(IRCTC_CREATE_ACCOUNT_COMPONENTS.successPage);
        // Form Submitted Successfully
      } else {
        updateShowErrorOtpPage(true);
      }
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error(error);
    }
  };

  useEffect(() => {
    // send OTP on Email and Mobile Both
    sendOtpToUser('B', true);
  }, []);
  return (
    <div className={`${customClass} getIrctcOtpVerify`}>
      <div className="flexOne">
        <h2>OTP Verification</h2>
        {isMobileDevice && showErrorOtpPage && (
          <p className="invalidError">{`Invalid Email/Mobile OTP Code for the user ${userName}`}</p>
        )}
        <div className={`getIrctcOtpVerify__cntnt ${!isMobileDevice && showErrorOtpPage ? 'errorClass' : ''}`}>
          {!isMobileDevice && showErrorOtpPage && (
            <p className="invalidError">{`Invalid Email/Mobile OTP Code for the user ${userName}`}</p>
          )}
          <div className={'makeFlex row hrtlCenter'}>
            <h3>IRCTC OTP sent</h3>
            <p className="timeTag pushRight">
              <span className="railSeoSprite whiteClock appendRight8"></span>
              {timerString}
            </p>
          </div>

          <p className={`font16 lineHeight24 ${!isMobileDevice ? 'appendBottom50' : 'appendBottom40'}`}>
            Please verify your email address and mobile number.
            <br />
            <span className="latoBold"> Check your email inbox and SMS app for OTPs from IRCTC</span>
          </p>
          <h4>Enter OTP received on email address</h4>
          <InputField
            type="text"
            value={emailCode}
            updateParentValue={updateEmailCode}
            placeholder={`OTP received on ${userEmail}`}
            customClass="appendBottom30"
          />
          <span
            className={`resendTimer ${timerExpired ? 'cursorPointer' : 'noDrop'}`}
            onClick={() => sendOtpToUser('E')}
          >{`Resend OTP on Email`}</span>
          <h4>Enter OTP recieved on mobile number</h4>
          <InputField
            type="text"
            value={smsCode}
            updateParentValue={updateSmsCode}
            placeholder={`OTP received on +91${mobileNumber}`}
            customClass="appendBottom30"
          />
          <span
            className={`resendTimer ${timerExpired ? 'cursorPointer' : 'noDrop'}`}
            onClick={() => sendOtpToUser('M')}
          >{`Resend OTP on mobile number`}</span>
          <button className={`blueButtonRails ${isMobileDevice ? 'fullWidth' : ''}`} onClick={submitOtpForm}>
            VERIFY
          </button>
        </div>
      </div>
      <FacingTrouble facingTroubleList={getFacingTroubleList(FACING_TROUBLE_PAGE_TITLE.CREATE_ACCOUNT_TITLE)} />
    </div>
  );
};

IrctcOtpVerifyPage.propTypes = {
  customClass: PropTypes.string
};

export default IrctcOtpVerifyPage;
